export default "__VITE_ASSET__CFfh8oUs__"